var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_287_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.11 23C10.994 22.9998 10.879 22.9795 10.77 22.94C10.5597 22.863 10.3814 22.7177 10.2636 22.5273C10.1457 22.3369 10.0952 22.1125 10.12 21.89L10.89 14.8H5C4.81833 14.8002 4.64002 14.751 4.48422 14.6576C4.32841 14.5642 4.201 14.4301 4.11567 14.2697C4.03034 14.1093 3.99031 13.9287 3.99988 13.7473C4.00945 13.5659 4.06827 13.3905 4.17 13.24L12.06 1.43998C12.1848 1.25531 12.3677 1.11763 12.5797 1.04878C12.7916 0.979939 13.0205 0.983877 13.23 1.05997C13.4314 1.13474 13.6033 1.27236 13.7204 1.45246C13.8375 1.63257 13.8934 1.84559 13.88 2.05998L13.11 9.19998H19C19.1817 9.1997 19.36 9.24892 19.5158 9.34235C19.6716 9.43578 19.799 9.56989 19.8843 9.73027C19.9697 9.89065 20.0097 10.0712 20.0001 10.2527C19.9905 10.4341 19.9317 10.6095 19.83 10.76L11.94 22.56C11.8483 22.6957 11.7246 22.8068 11.5799 22.8835C11.4352 22.9602 11.2738 23.0002 11.11 23Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/Flash.0a3bdf551645793acd0a6b85afaa3c46.svg";
export { ForwardRef as ReactComponent };